

















import { listFactory } from '@/main/pages/listFactory';

import { store } from './store/list';
import { NAME } from './constants';

export default listFactory(NAME, store);
